/**
 * @author Cristyan Fernando Ballesteros
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    // 'sidebar.reportes': 'Reports',
    // 'sidebar.reportegeneral': 'General Report',
    // 'sidebar.inventariocoimpresores': 'Coimpresores Inventory Report',
    // 'sidebar.ReporteInventarioCoimpresores': 'Inventory Report',
    // 'sidebar.ReporteMovimiento': 'Movement Report',
    // 'sidebar.movimiento': 'Movement Report',
    // 'sidebar.movimientoinventario':'Inventory Movement Report',
    // 'sidebar.kardex':'Report Kardex',
    // 'sidebar.reporteKardex':'Report Kardex',
    // 'permiso.reportemovimientoinventario':'Inventory movement report permission'

    'sidebar.reportes': 'Reports',
    'sidebar.ReporteSabanaInformacion':'Sheet Information',
    'sidebar.reportegeneral': 'General Report',
    'sidebar.ReporteMovimiento': 'Movement Report',
    'sidebar.movimiento': 'Movement Report',
    'sidebar.reportesabanainformacion': 'Information Sheet  ',
    'sidebar.movimientoinventario':'Inventory Movement Report',
    'permiso.reportemovimientoinventario':'Inventory movement report permission'
};
